import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'landing-footer',
  templateUrl: './landing-footer.component.html',
})
export class LandingFooterComponent implements OnInit {
  year: number = 0;

  constructor() {}

  ngOnInit(): void {
    const date = new Date();
    this.year = date.getFullYear();
  }
}
